const faq = {
    /**
     * Initializes every FAQ block inside root, or root itself when it is one.
     * Safe to call repeatedly: ACF replaces the preview DOM after every field change.
     */
    init: function( root, options = {} ) {
        const scope  = root || document;
        const blocks = [];

        if ( scope.matches && scope.matches('.faq') ) {
            blocks.push( scope );
        }

        if ( scope.querySelectorAll ) {
            blocks.push( ...scope.querySelectorAll('.faq') );
        }

        blocks.forEach( (block) => {
            this.bindBlock( block, options );
        });
    },

    bindBlock: function( block, options = {} ) {
        const items = block.querySelectorAll('.faq__item');

        if ( ! items.length ) {
            return;
        }

        items.forEach( (item) => {
            this.bindItem( item, options );
        });
    },

    bindItem: function( item ) {
        const question = item.querySelector('.faq__question');
        const answer   = item.querySelector('.faq__answer');

        if ( ! question || ! answer || item.dataset.faqReady === 'true' ) {
            return;
        }

        item.dataset.faqReady = 'true';

        question.addEventListener('click', () => {
            const isExpanded = question.getAttribute('aria-expanded') === 'true';
            this.toggle( item, question, answer, ! isExpanded );
        });
    },

    toggle: function( item, question, answer, open ) {
        if ( open ) {
            item.classList.add('is-active');
            question.setAttribute('aria-expanded', 'true');
            answer.setAttribute('aria-hidden', 'false');
            answer.style.maxHeight = answer.scrollHeight + 'px';
        } else {
            item.classList.remove('is-active');
            question.setAttribute('aria-expanded', 'false');
            answer.setAttribute('aria-hidden', 'true');
            answer.style.maxHeight = '0';
        }
    }
};

export default faq;

// The editor boots this module through src/js/_editor.js instead.
if ( ! window.acf ) {
    if ( document.readyState === 'loading' ) {
        document.addEventListener('DOMContentLoaded', () => faq.init( document, { isEditor: false } ));
    } else {
        faq.init( document, { isEditor: false } );
    }
}
